export default __webpack_public_path__ + "static/media/portfolioReportingLogo.d5bc7b30.svg";